import type { Palette } from '@mui/material/styles';
import { buildCustomColors } from './tokens/buildCustomColors';
import { buildPaletteOptions } from './tokens/buildPalette';
import type { AridePaletteMode } from './tokens/buildPalette';

export const defaultPaletteMode: AridePaletteMode = 'dark';

/** Paleta MUI para o modo atual (e-commerce usa escuro por defeito). */
const colors = buildPaletteOptions(defaultPaletteMode) as Partial<Palette>;

export const customColors = buildCustomColors(defaultPaletteMode);

export function getAridePalette(mode: AridePaletteMode): Partial<Palette> {
  return buildPaletteOptions(mode) as Partial<Palette>;
}

export function getArideCustomColors(mode: AridePaletteMode) {
  return buildCustomColors(mode);
}

export default colors;
